import { useState } from "react";
import { Lightning } from "@phosphor-icons/react";
import { adminApi, detail, expiresText, PLAN } from "@/lib/adminApi";
import { StatusBadge } from "@/components/admin/DeviceCard";

const ACTIONS = [
  { id: "yearly", label: "Godišnje 9.99€" },
  { id: "lifetime", label: "Doživotno 29.99€" },
  { id: "trial", label: "Proba X dana" },
];

export const QuickActivate = ({ runAction }) => {
  const [q, setQ] = useState("");
  const [action, setAction] = useState("yearly");
  const [days, setDays] = useState(7);
  const [found, setFound] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const find = async () => {
    setBusy(true); setError(""); setFound(null);
    try {
      const r = await adminApi.get("/admin/devices", { params: { q: q.trim() } });
      if (!r.data.length) setError("Uređaj nije pronađen");
      else setFound(r.data[0]);
    } catch (e) { setError(detail(e)); }
    finally { setBusy(false); }
  };

  const run = async () => {
    const id = { device_id: found.device_id };
    const call = action === "trial"
      ? () => adminApi.post("/admin/devices/grant-trial", { ...id, days: Number(days) || 7 })
      : () => adminApi.post("/admin/devices/activate", { ...id, plan: action });
    const r = await runAction(call, action === "trial" ? `Proba ${days} dana dodeljena.` : `Uređaj aktiviran (${PLAN[action].toLowerCase()}).`);
    if (r) setFound({ ...found, ...r.data });
  };

  return (
    <div className="rounded-2xl border border-brand/40 bg-surface2 p-5" data-testid="quick-activate">
      <div className="flex items-center gap-2"><Lightning size={18} weight="fill" className="text-brand" /><h2 className="font-bold">Brza ručna aktivacija</h2></div>
      <form onSubmit={(e) => { e.preventDefault(); if (q.trim()) find(); }} className="mt-3 flex flex-col gap-2 md:flex-row">
        <input className="input flex-1" placeholder="Device Key ili MAC" value={q} onChange={(e) => { setQ(e.target.value); setFound(null); }} data-testid="quick-activate-input" />
        <button type="submit" disabled={busy || !q.trim()} className="btn-ghost disabled:opacity-40" data-testid="quick-activate-find-btn">{busy ? "Traženje…" : "Pronađi"}</button>
      </form>
      {error && <p className="mt-2 text-sm text-err" data-testid="quick-activate-error">{error}</p>}
      {found && (
        <div className="mt-4 flex flex-col gap-3 rounded-xl border border-line bg-surface p-4" data-testid="quick-activate-found">
          <div className="flex flex-wrap items-center gap-3">
            <span className="text-xl font-bold tracking-[3px]">{found.device_key}</span>
            <span className="font-mono text-xs text-txt2">{found.mac}</span>
            <StatusBadge status={found.status} />
            <span className="text-xs text-muted2">{PLAN[found.plan] || found.plan} • {expiresText(found)}</span>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {ACTIONS.map((a) => (
              <button key={a.id} onClick={() => setAction(a.id)} data-testid={`quick-action-${a.id}`}
                className={`rounded-full border px-3.5 py-1.5 text-xs font-semibold ${action === a.id ? "border-brand bg-brand text-white" : "border-lineStrong text-txt2"}`}>
                {a.id === "trial" ? `Proba ${days} dana` : a.label}
              </button>
            ))}
            {action === "trial" && <input type="number" min={1} max={3650} value={days} onChange={(e) => setDays(e.target.value)} className="input w-20 py-1.5 text-sm" data-testid="quick-trial-days" />}
            <button onClick={run} className="btn-primary ml-auto px-5 py-2.5 text-sm" data-testid="quick-activate-submit">Aktiviraj</button>
          </div>
        </div>
      )}
    </div>
  );
};
